import { render, staticRenderFns } from "./PhysicalCheck.vue?vue&type=template&id=d64355f2&scoped=true"
import script from "./PhysicalCheck.vue?vue&type=script&lang=js"
export * from "./PhysicalCheck.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCheck.vue?vue&type=style&index=0&id=d64355f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64355f2",
  null
  
)

export default component.exports